<template>
  <form class="space-y-6" @submit.prevent="submit">
    <div class="grid grid-cols-1 gap-6 sm:grid-cols-2">
      <div class="sm:col-span-1">
        <InputGroup
          v-model="form.name"
          required
          label="Full Name"
          placeholder="Enter your full name"
          class="w-full"
          :error="errors?.name?.[0]"
        />
      </div>
      <div class="sm:col-span-1">
        <InputGroup
          v-model="form.email"
          required
          label="Email Address"
          type="email"
          placeholder="Enter your email"
          class="w-full"
          :error="errors?.email?.[0]"
        />
      </div>
    </div>

    <div>
      <InputGroup
        v-model="form.message"
        required
        :rows="6"
        label="Project Details"
        type="textarea"
        placeholder="Tell us about your project, timeline, and any specific requirements..."
        class="w-full"
        :error="errors?.message?.[0]"
      />
    </div>

    <!-- Form Footer -->
    <div class="border-t border-gray-200 pt-4 dark:border-gray-700">
      <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div class="text-sm text-gray-500 dark:text-gray-400">
          <p>We'll get back to you within 24 hours</p>
        </div>
        <slot :loading="loading" />
      </div>
    </div>
  </form>
</template>

<script setup lang="ts">
import InputGroup from '~/components/UI/InputGroup.vue'

const initialForm = {
  name: '',
  email: '',
  message: '',
}

const form = ref({ ...initialForm })
const loading = ref(false)
const errors = ref<Record<string, string[]>>({})
const { addToast } = useToast()
const config = useRuntimeConfig()

async function submit () {
  if (loading.value) { return }
  loading.value = true
  errors.value = {}
  try {
    await $fetch(`${config.public.apiUrl}/api/contact`, { method: 'POST', body: form.value })
    form.value = { ...initialForm }
    addToast({
      title: 'Sent',
      text: 'Thank you for reaching out, we\'ll respond shortly!',
      type: 'info',
    })
  } catch (e: any) {
    if (e?.response?.status === 422) {
      errors.value = e.data?.errors ?? {}
    }
    if (e?.data?.message) {
      addToast({ title: 'Error', text: e.data.message, type: 'error' })
    }
    console.error(e)
  } finally {
    loading.value = false
  }
}
</script>
